// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Vue2OrgTree from 'vue2-org-tree'
import 'vue2-org-tree/dist/style.css'
import router from './router'
import VueRouter from 'vue-router'
import htmlToPdf from "@/utils/htmlToPdf"

Vue.use(htmlToPdf)

Vue.use(Vue2OrgTree)
Vue.use(VueRouter)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router: router,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js